module.exports = __webpack_public_path__ + "static/media/pencil.2b48d6a0.svg";